import requests from './httpService';
const EventService = {
  deleteAzureImage(body){
    return requests.post(`/event/deleteazureimage`,body);

  },

  getStudentEvent(body){
    return requests.post(`/event/events`,body);

  },
  getAllEvent() {
    return requests.get(`/event/list`);
  },
  getEventbyId(id) {
    return requests.get(`/event/${id}`);
  },
  uploadImage(body) {
    return requests.post(`/event/uploadimage`,body);
  },
  creteImages(body){
    return requests.post('/image/add',body);
  },
  creteEvent(body){
    return requests.post('/event/add',body); 
  },
  deleteEvent(body){
    return requests.delete(`/event/${body._id}`); 
  },
  findEventList(body){
    return requests.post(`/event/find`,body); 
  },
  calenderassignmentList(body){
    return requests.post(`/calenderassignment/find`,body); 
  },
  calenderassignmentFind(id){
    return requests.get(`/calenderassignment/${id}`); 
  },
  // upadeTeacher(body) {
  //   return requests.put(`/teacher/${body._id}`,body); 
  // },
  upadeEvent(body) {
    return requests.put(`/event/${body._id}`,body); 
  },
  upadeStudentEvent(body) {
    return requests.put(`/event/studentactivity/${body._id}`,body); 
  },
  

};
export default EventService;
